import { View } from "react-native";
import { useTailwind } from "tailwind-rn";

import TextLabel from "./TextLabel";
import { CostaRicaBank as TCostaRicaBank } from "../../../types";
import CardText from "../../CardText";

type Props = {
  bank?: TCostaRicaBank;
};

export default function CostaRicaBank({ bank }: Props) {
  if (!bank) return null;

  const { ibanNumber, idType, idNumber, bankCurrency } = bank;
  return (
    <View>
      <Segment title="IBAN" text={ibanNumber} label={bankCurrency} />
      <Segment title="Identificación" text={idNumber} label={idType} />
    </View>
  );
}

type SegmentProps = {
  title: string;
  text: string;
  label: string;
};

function Segment({ title, text, label }: SegmentProps) {
  const tailwind = useTailwind();
  return (
    <View>
      <CardText.Subtitle text={title} style={tailwind("mt-2")} />
      <View style={tailwind("flex-row justify-between mt-2")}>
        <CardText.Body text={text} />
        <TextLabel text={label} />
      </View>
    </View>
  );
}
